import LabelAnalytics from 'routes/LabelAnalytics/LabelAnalytics';

export default LabelAnalytics;
